import React from "react";

import cn from "classnames";

import styles from "./DescriptionColumn.module.scss";

interface Props {
  bigTitle?: boolean;
  className?: string;
  description?: React.ReactNode;
  title: React.ReactNode;
}

const DescriptionColumn: React.FC<Props> = ({ bigTitle, className, description, title }) => {
  return (
    <div className={cn(styles.container, className)}>
      <div
        className={cn(styles.title, {
          [styles.bigTitle]: bigTitle,
        })}
      >
        {title}
      </div>
      {description && <div className={styles.description}>{description}</div>}
    </div>
  );
};

export default DescriptionColumn;
